import { string as yupString } from 'yup';
import { translate } from '../../locales/i18n';

const reviewValidation = yupString()
  .min(20, (opts) => translate('validation_review_short', opts))
  // FIXME(clairbee): starts uppercase
  // FIXME(clairbee): not all caps
  .required(() => translate('validation_review_required'));

export {
  reviewValidation,
};
